/**
 * Tech occupation group IDs used to identify users in technology-related roles.
 * These groups determine tech learner status for conditional feature rendering.
 */
export const OCCUPATION_GROUPS = {
    SOFTWARE_DEVELOPER: 253,
    DATA_ANALYTICS: 231,
    INFORMATION_TECHNOLOGY: 243,
} as const;

/**
 * Tech occupation group IDs.
 */
export const TECH_OCCUPATION_GROUP_IDS: number[] = Object.values(OCCUPATION_GROUPS);
